// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetSystemListApiParameter extends ApiParameter {
    systemList: string;
    result: any;
}
export interface SystemListApiParameter extends ApiParameter {
    systemListName: string;
}
export interface SystemListModel {
    id?: string;
    name: string;
    description: string;
}

const systemListUrl = "/api/str/systemList/GetSystemListValues";
export interface SystemListCollectionModel {
    systemListDescription: string;
    systemListName: string;
    values: SystemListModel[];
}

export async function getSystemList(parameter: SystemListApiParameter) {
    const systemListCollection = await get<SystemListCollectionModel>(systemListUrl, parameter);
    return systemListCollection;
}
